<template>

  <Toast :group="page.name" position="bottom-center" />
  <Loader v-if="loader" />


  <div class="page">
    <div>
      <div class="card">
          <div class="formgrid grid">
            <div class="field col-12">
              <label>Data</label>
              <Calendar class="w-full" v-model="date" dateFormat="yy" view="year" :showIcon="true" />
              <div v-show="validationErrors.date && submitted" class="p-error">Campo richiesto.</div>
            </div>
          </div>
      </div>
      <small class="text-500">Potrebbe richiedere fino a 10 minuti</small>
    </div>
  </div>
  <div class="wrap-footer-main-dialog">
    <div class="footer-main-dialog">
      <Button 
          label="Chiudi" 
          icon="pi pi-times"
          iconPos="right" 
          class="p-button-secondary mr-3"
          @click="onCancelButton($event)" 
        />
        <Button 
          label="Esegui" 
          icon="pi pi-check"
          iconPos="right" 
          class="mr-3"
          @click="onOkButton($event)" 
        />
    </div>
  </div>

</template>

<script>

import { ref, getCurrentInstance} from 'vue';
import Service from '@/services/ask-operation/operation-service'
import Loader from '@/components/Loader.vue'
import moment from 'moment';

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  components: {
    Loader
  },
    
  setup() {
    const page = { name: 'pods-consumi-dispacciamento'}
    const loader = ref(false)
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const service = new Service(self.$http, self.$eventBus)
    const date = ref()
    const validationErrors = ref({})
    const submitted = ref(false)
      
      
    const onOkButton = () => {
      submitted.value = true;
      if (validateForm() ) {
        loader.value = true
        let d = moment(date.value).format('YYYY')
        service.downloadConsumiDispacciamentoFile(d)
        .finally(()=>{
          loader.value = false
          // self.$eventBus.emit(`dialog-return-ok-button`, {}) 
        })            

      }
    }
    


    const onCancelButton = () => {
       self.$eventBus.emit(`dialog-return-cancel-button`, {})
    }


    const validateForm = () => {

      if (date.value) {
        delete validationErrors.value['date'];
      } else {
        validationErrors.value['date'] = true;
      }

      return !Object.keys(validationErrors.value).length;
    }


    return {
      page,
      date,
      loader,
      validationErrors, 
      submitted,
      onCancelButton,
      onOkButton
    }
  }
}


</script>



